import lang from "@/views/modules/EdRequests/language/en";
let metaList = [
    {
        label: lang.LBL_REQUEST_BY,
        link: true,
        columnName: 'created_by',
    },
    {
        label: lang.LBL_REQUEST_TO,
        link: true,
        columnName: 'assigned_user',
    },
    {
        label: lang.LBL_DESCRIPTION,
        link: false,
        columnName: 'description',
    },
    {
        label: lang.LBL_REQUEST_STATUS,
        link: false,
        columnName: 'status',
    },
];
const link_list = {
    routePath: 'edrequests',
    title: 'Recent Active Ed Requests',
    search: {},
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }